import {Button, Form, Input, Select} from "antd";
import {useRef} from "react";
import {t} from "i18next";

export default function StateDescriptionForm({descList, onOk, onCancel}) {
    const formRef = useRef()

    return (
        <>
            <Form
                ref={formRef}
                layout={'vertical'}
                initialValues={{
                    descId: descList && descList[0]?.id
                }}
                onFinish={() => {
                    onOk && onOk(formRef.current.getFieldsValue());
                }}
            >
                <Form.Item
                    label={t('Reason')}
                    name={'descId'}
                    required={true}
                >
                    <Select
                        size={'small'}
                        style={{width: 300}}
                    >
                        {
                            descList.map((desc) => (
                                <Select.Option value={desc.id} key={desc.id}>
                                    {desc.text}
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    label={t('Description')}
                    name={'description'}
                >
                    <Input.TextArea
                        rows={4}
                    />
                </Form.Item>
                <div style={{display: 'flex', alignContent: 'center', gap: 8}}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" size={'small'}>
                            {t('Okay')}
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" danger={true} size={'small'} onClick={onCancel}>
                            {t('Cancel')}
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </>
    )
}